import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { OAuthResourceServerErrorHandler, OAuthStorage } from 'angular-oauth2-oidc';

@Injectable({ providedIn: 'root' })
export class OAuthInterceptor implements HttpInterceptor {
  private readonly authStorage = inject(OAuthStorage);
  private readonly errorHandler = inject(OAuthResourceServerErrorHandler);

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authStorage.getItem('access_token');

    const header = 'Bearer ' + token;

    const headers = req.headers.set('Authorization', header);

    req = req.clone({ headers });

    return next.handle(req).pipe(catchError((err) => this.errorHandler.handleError(err)));
  }
}
